import React from 'react'
import PageHead from '../components/PageHead'
import Shipping from '../components/settings/Shipping'
import StoreSettings from '../components/settings/StoreSettings'

function Setting() {
    return (
        <div className='w-full relative'>
            {/* Head */}
            <PageHead title={"Settings"} />

            {/* Shipping */}
            <div className="mt-7 space-y-8">
                <Shipping />
                <StoreSettings />
            </div>

        </div>
    )
}

export default Setting